var lx = lx || {};
lx.oldir = lx.oldir || {};
lx.oldir.srch = lx.oldir.srch || {};
lx.apexir = lx.apexir || {};

lx.oldir.exe = function (pCode, pPage, pParams) {
    lx.load.add();
    var vCode = pCode,
        vPage = pPage,
        vParams = pParams,
        vDates, vSearch, vHide, vHideOld;

    if (!pCode) vCode = $(".lxIrCode").val();
    var $vIR = $("#IR-" + vCode);
    if (pCode) $vIR.find(".lxIrCode").val(vCode);

    vSearch = $vIR.find('.lxIrSearch').val();
    if (vSearch.length < 3) vSearch = "";

    if (!pPage) vPage = $vIR.find(".lxIrPage").val();
    else $vIR.find(".lxIrPage").val(vPage);

    if (!pParams) vParams = $vIR.find(".lxIrParams").val();
    else $vIR.find(".lxIrParams").val(vParams);

    vHideOld = $vIR.find(".lxHideIrSearch").val();
    vHide = ((vHideOld == 1) ? 2 : vHideOld);
    vDates = $vIR.find(".lxIrDateFrom").val() + ":" + $vIR.find(".lxIrDateTo").val();

    $.ajax({
        url: "wwv_flow.show",
        dataType: "html",
        traditional: true,
        cache: false,
        type: "GET",
        data: {
            p_flow_id: $v("pFlowId"),
            p_flow_step_id: $v("pFlowStepId"),
            p_instance: $v("pInstance"),
            p_request: "APPLICATION_PROCESS=lxIR",
            x01: vCode,
            x02: vPage,
            x03: vParams,
            x04: vSearch,
            x05: $vIR.find('.lxIrSearchCol').val(),
            x06: vHide,
            x07: vDates
        },
        success: function (d) {
			lx.load.remove();
            $vIR.replaceWith(d);
            $vIR = $("#IR-" + vCode);
            $vIR.find(".lxIrSearch").focus();
            if (vHideOld == 1) {
                $(".lxHideOnIrSearch").hide();
                $vIR.find(".lxReportSearch").append('<div class="lxReportSearchBtn lxHideOffIrSearch" onclick="lx.oldir.hide(this);">Back</div>');
            } else if (vHideOld == 2) {
                $vIR.find(".lxReportSearch").append('<div class="lxReportSearchBtn lxHideOffIrSearch" onclick="lx.oldir.hide(this);">Back</div>');
            }
        }
    });
};

/*Previous - lxIrInit*/
lx.oldir.init = function (pIrCode) {
    var $vIR = $("#IR-" + pIrCode);
    $(".lxReportSearch input.lxIrDateField[type=text]").datepicker({ dateFormat: translation.date_format });
};

/*Previous - lxIrSrch*/
lx.oldir.srch.exe = function (pCode) {
    var vLength = $("#IR-" + pCode).find(".lxIrSearch").val().length;
    if (vLength > 0 && vLength < 3)
        alert("Please enter at least 3 charcters!");
    else lx.oldir.exe(pCode, 1);
};

/*Previous - setSearchColumn*/
lx.oldir.srch.setCol2 = function (pName, pColumn, pStaticId) {
    $.ajax({
        url: "wwv_flow.show",
        dataType: "html",
        traditional: true,
        cache: false,
        type: "POST",
        data: {
            p_flow_id: $v("pFlowId"),
            p_flow_step_id: $v("pFlowStepId"),
            p_instance: $v("pInstance"),
            p_request: "APPLICATION_PROCESS=defaultIRcolumn",
            x01: pName
        },
        success: function (d) {
            var vIRid = "";
            var vSearch = apex.lang.getMessage("JS41");
            if (pStaticId) {
                vIRid = "#" + pStaticId + " "
            }
            $(vIRid + "#pgIR1_column_search_current_column").val(pColumn);
            $(vIRid + "#pgIR1_search_field").attr("title", vSearch + ": " + d).attr("placeholder", vSearch + ": " + d);

        }
    })
};

/*Previous - lxIrSetSearchCol*/
lx.oldir.srch.setCol = function (pThis, pCol) {
    var $srch = $(pThis).closest(".lxReportSearch");
    $srch.find(".lxIrSearchCol").val(pCol);
    $srch.find(".lxIrSearch").attr("placeholder", $(pThis).text()).focus();
    //$(pThis).parent().addClass("hideme");//.hide().css('display','none');
    //alert($(pThis).parent().html());
};

/* Created on 26.4.2017 by Davor
* Used in profile Directory to bring up more info
Previous - lxProfBoxMore
*/
lx.oldir.lxProfBoxMore = function(pThis) {
    var $btn = $(pThis);
    var $container = $btn.parent().find(".lxProfBoxAddon");
    $container.toggleClass("open");
    $btn.toggleClass("open");
    $(".lxProfBoxAddon.open").not($container).removeClass("open");
    $(".lxProfBox .dots.open").not($btn).removeClass("open");
}

// Previous - handleAction
// Handle connection action  //
//////////////////////////////
var vLxBtnType; //Stores button type (link, button) for connectDialog
var confirmDialog;

lx.oldir.handleAction = function(pValues) {
    var confirmDiv;
    var confirmPar = "DRCHTQ";
    if (pValues.response == null && (confirmPar.indexOf(pValues.par) > -1 || (pValues.par == "P" && pValues.mode == "O"))) {
        confirmDiv = "<div class='connectionConfirm'><div class='connectionConfirmTxt'>";
        if (pValues.par == 'D' && pValues.type != 'CLI') confirmDiv += "<div class='connectionConfirmWarn'>" + apex.lang.getMessage("JS55") + "</div>";
        confirmDiv += apex.lang.getMessage("JS22") + "</div><div class='connectionConfirmBtns'><a href='#' role='button'></a>" +
            "<a id='lxConnDialogYes' href='javascript:void(0);' class='m-btn gray mini' role='button'><span>" +
            apex.lang.getMessage("YES") + "</span></a>" +
            "<a id='lxConnDialogCancel' href='javascript:void(0);' class='m-btn blue mini' role='button'><span>" +
            apex.lang.getMessage("JS24") + "</span></a>";
        confirmDialog = $(confirmDiv).dialog({
            resizable: false,
            width: 350,
            modal: true,
            close: function (event, ui) {
                $("#lxConnDialogYes").unbind();
                $("#lxConnDialogCancel").unbind();
                $(confirmDialog).dialog("destroy");
            }
        });
        $("#lxConnDialogYes").click(function () {
            pValues.response = 'Y';
            handleAction(pValues);
            $(confirmDialog).dialog("close");
        });
        $("#lxConnDialogCancel").click(function () {
            $(confirmDialog).dialog("close");
        });
        return;
    } else if (pValues.response == null) {
        pValues.response = 'Y';
    }

    $(".lx_profile_buttons .lx_profile_buttons_" + pValues.id).html("Processing Response");
    lxLoad();
    $.ajax({
        url: "wwv_flow.show",
        dataType: "html",
        traditional: true,
        cache: false,
        type: "POST",
        data: {
            p_flow_id: $v("pFlowId"),
            p_flow_step_id: $v("pFlowStepId"),
            p_instance: $v("pInstance"),
            p_request: "APPLICATION_PROCESS=handleAction",
            x01: pValues.type,
            x02: pValues.id,
            x03: pValues.par,
            x04: pValues.sub,
            x05: pValues.text,
            x06: pValues.btn,
            x07: pValues.acnId,
            x08: pValues.response,
            x09: pValues.mode
        },
        success: function (d) {
            //lxLoadRemove();
			lx.load.remove;
            if (lxSubDialog) if (lxSubDialog.dialog('isOpen')) showMemberships(lxSubDialogVals.profileId, lxSubDialogVals.mode, lxSubDialogVals.btnType, lxSubDialogVals.single);
            if (pValues.btn == 'A' || pValues.btn == 'F') {
                $.ajax({
                    url: "wwv_flow.show",
                    dataType: "html",
                    traditional: true,
                    cache: false,
                    type: "POST",
                    data: {
                        p_flow_id: $v("pFlowId"),
                        p_flow_step_id: $v("pFlowStepId"),
                        p_instance: $v("pInstance"),
                        p_request: "APPLICATION_PROCESS=getLastNotifyFromObject",
                        x01: 57,
                        x02: pValues.id,
                        x03: ""
                    },
                    success: function (dNot) {
                        $(".lx_profile_buttons_" + pValues.id).closest('.feed-post').replaceWith(dNot);
                    }
                });
            } else if (pValues.btn == 'R') {
                lxLoad(); window.location.reload();
            } else {
                $(".lx_profile_buttons .lx_profile_buttons_" + pValues.id).replaceWith(d);
            }
            if ($(".a-IRR-custom").length > 0) lxIR();
        }
    });
}


// Previous - showMemberships 
var lxSubDialog, lxSubDialogVals;

lx.oldir.showMemberships = function(pProfileId, pMode, pBtnType, pSingle) {
    var vWidth = 800;
    lxSubDialogVals = { profileId: pProfileId, mode: pMode, btnType: pBtnType, single: pSingle };
    //showMemberships(lxSubDialogVals.profileId,lxSubDialogVals.mode,lxSubDialogVals.btnType,lxSubDialogVals.single);
    if (pSingle) vWidth = 800;
    $.ajax({
        url: "wwv_flow.show",
        dataType: "html",
        traditional: true,
        cache: false,
        type: "POST",
        data: {
            p_flow_id: $v("pFlowId"),
            p_flow_step_id: $v("pFlowStepId"),
            p_instance: $v("pInstance"),
            p_request: "APPLICATION_PROCESS=getAjax",
            x01: "SUB",
            x02: pProfileId,
            x03: "0:" + pMode + ":" + pBtnType
        },
        success: function (d) {
            if (lxSubDialog) if (lxSubDialog.dialog('isOpen')) lxSubDialog.dialog("close");
            lxSubDialog = $(d).dialog({
                width: vWidth,
                modal: true
            });
        }
    });
};

lx.oldir.refresh = function(pId) {
    if ($(".a-IRR-custom").length == 1) {
        lx.oldir.exe();
    } else if ($("#IR-" + pId).length == 1) {
        lx.oldir.exe(pId);
    } else if (pId) {
		apex.region(pId).refresh();
    } else {
		apex.region("pgIR1").refresh();
    }
};

lx.oldir.setDetailView = function () {
    if ($('button.a-IRR-button--views[data-view=details]').hasClass("is-active") == false) {
        $('button.a-IRR-button--views[data-view=details]').click();
    }
};

lx.oldir.hide = function (pThis) {
    $(".lxHideOnIrSearch").show();
    $(".lxHideOffIrSearch").hide();
    $(pThis).closest(".a-IRR-custom").find(".a-IRR-reportView,.lxIrPagination").hide();
    $(pThis).closest(".a-IRR-custom").find(".lxHideIrSearch").val(1);
    //toggleContentWidth();
};

lx.oldir.genRoles = function (pId, pAdtId, pThis) {
    $popup = $(pThis).siblings(".lxDocLinksPopup");
    $(".lxIrPopup:visible").hide();
    if ($popup.length > 0) {
        $popup.show();
    } else {
        $.ajax({
            url: "wwv_flow.show",
            dataType: "html",
            traditional: true,
            cache: false,
            type: "POST",
            data: {
                p_flow_id: $v("pFlowId"),
                p_flow_step_id: $v('pFlowStepId'),
                p_instance: $v("pInstance"),
                p_request: "APPLICATION_PROCESS=genRoles",
                x01: pId,
                x02: pAdtId
            },
            success: function (d) {
                $(pThis).after("<div class='lxIrPopup lxDocLinksPopup'><div class='lxIrPopupHdr'>Approvals<span onclick='$(this).closest(\".lxIrPopup\").hide();'>x</span></div><div class='col col-12 apex-col-auto' style='padding:0.8rem;'>" + d + "</div></div>");
            }
        });
    }
};



lx.oldir.spCheckChange = function(pThis) {
    //alert(pThis.value);
    apex.server.process("CHECKBOX_CHANGE", {
        x01: pThis.value, //Value that was checked
        x02: pThis.checked ? 'Y' : 'N' // Checked Flag
    }, {
            dataType: 'text',
            success: function (d) {
                $x('checkListDisp').innerHTML = d;
            }
        });
}


// Project/Task IR related
lx.oldir.lxHint = function() {
    this.xOffset = 0; // x distance from mouse
    this.yOffset = 10; // y distance from mouse
    jQuery(".lx-hint-container").hover(function (e) {
        var insideText = jQuery(".lx-hint", this).html();
        this.top = (e.pageY + 10);
        this.left = (e.pageX + 0);
        $('body').append('<div id="lxHint" style="overflow:hidden;" class="tooltip">' + insideText + '</div>');
        $('div#lxHint').css("top", this.top + "px").css("left", this.left + "px").delay(100).fadeIn("fast");
    },
        function () {
            jQuery("div#lxHint").fadeOut("false").remove();
        }).mousemove(
            function (e) {
                this.top = (e.pageY + 10);
                this.left = (e.pageX + 0);
                jQuery("div#lxHint").css("top", this.top + "px").css("left", this.left + "px");
            }
        );
}

lx.oldir.setContainerHeight = function() {
    var h = $(window).height();
    var w = $(window).width();
    var th = $("#task_info .project_title").height();
    $(".project_list-container .task_info_container").css('height', (h < 600) ? 438 : (h - 162));
    $(".project_info .task_info_container").css('height', (h < 600) ? 438 : (h - 162)); //500
    $("#task_info .task_info_container").css('height', (h < 600) ? (458 - th) : (h - (142 + th))); //520
}

lx.oldir.searchProject = function() {
    $('#uiProjSearch').keyup(function() {
        $('.ui-proj-list').hide();
        var txt = $('#uiProjSearch').val();
        $('.ui-proj-list').each(function() {
            if ($(this).text().toUpperCase().indexOf(txt.toUpperCase()) != -1) {
                $(this).show();
            }
        });
    }).focus();
}

// TODO cleanup after we ditch the old app
var lxIR = lx.oldir.exe;
var lxIrInit = lx.oldir.init;
var lxIrSrch = lx.oldir.srch.exe;
var lxIrSetSearchCol = lx.oldir.srch.setCol;
var setSearchColumn = lx.oldir.srch.setCol2;
var lxProfBoxMore = lx.oldir.lxProfBoxMore;
var handleAction = lx.oldir.handleAction;
var showMemberships = lx.oldir.showMemberships;
var refresh_ir_report = lx.oldir.refresh;
var setDetailView = lx.oldir.setDetailView;
var lxIrHide = lx.oldir.hide;
var genRoles = lx.oldir.genRoles;
var spCheckChange = lx.oldir.spCheckChange;
var lxHint = lx.oldir.lxHint;
var setContainerHeight = lx.oldir.setContainerHeight;
var searchProject = lx.oldir.searchProject;